const settingsCookieName = "strengthlevelsettings";

function readCookie(name) {
    const prefix = name + "=";
    const parts = document.cookie ? document.cookie.split(";") : [];
    for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (part.indexOf(prefix) === 0) {
            try {
                return decodeURIComponent(part.substring(prefix.length));
            } catch (e) {
                return null;
            }
        }
    }
    return null;
}

function readSettings() {
    const value = readCookie(settingsCookieName);
    if (!value) {
        return null;
    }
    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
}

function getTabContainer(label) {
    const containers = document.querySelectorAll("[data-tab-group]");
    for (let i = 0; i < containers.length; i++) {
        if (containers[i].getAttribute("data-tab-group") === label) {
            return containers[i];
        }
    }
    return null;
}

function getTabGender(tab) {
    return (tab && tab.getAttribute("data-tab") || "").toLowerCase();
}

function setFormValue(form, name, value) {
    const input = form.querySelector("[name='" + name + "']");
    if (input && input.type !== "hidden" && value !== undefined && value !== null && value !== "") {
        input.value = value;
    }
}

function initStandardsCalculatorForm(form) {
    const genderSelect = form.querySelector("[data-standards-calculator-gender]");
    const tabContainer = getTabContainer(form.dataset.genderTabGroup);
    const genderTabs = tabContainer ? tabContainer.querySelectorAll(".tabs li[data-tab]") : [];

    function activateGenderTab(gender) {
        for (let i = 0; i < genderTabs.length; i++) {
            if (getTabGender(genderTabs[i]) === gender) {
                if (!genderTabs[i].classList.contains("is-active")) {
                    const anchor = genderTabs[i].querySelector("a");
                    if (anchor) {
                        anchor.click();
                    }
                }
                return;
            }
        }
    }

    for (let i = 0; i < genderTabs.length; i++) {
        genderTabs[i].addEventListener("click", function () {
            if (genderSelect) {
                genderSelect.value = getTabGender(genderTabs[i]);
            }
        });
    }

    if (genderSelect) {
        genderSelect.addEventListener("change", function () {
            activateGenderTab(genderSelect.value);
        });

        for (let i = 0; i < genderTabs.length; i++) {
            if (genderTabs[i].classList.contains("is-active")) {
                genderSelect.value = getTabGender(genderTabs[i]);
                break;
            }
        }
    }

    const settings = readSettings();
    if (settings && settings.exercise === form.dataset.exercise) {
        if (genderSelect && (settings.gender === "male" || settings.gender === "female")) {
            genderSelect.value = settings.gender;
            activateGenderTab(settings.gender);
        }
        setFormValue(form, "ageyears", settings.ageyears);
        if (settings.bodymassunit === form.dataset.unit) {
            setFormValue(form, "bodymass", settings.bodymass);
        }
        if (settings.liftmassunit === form.dataset.unit) {
            setFormValue(form, "liftmass", settings.liftmass);
        }
        setFormValue(form, "repetitions", settings.repetitions);
        setFormValue(form, "time", settings.time);
    }
}

export function initStandardsCalculatorForms() {
    const forms = document.querySelectorAll("[data-standards-calculator]");
    for (let i = 0; i < forms.length; i++) {
        initStandardsCalculatorForm(forms[i]);
    }
}
